<div class="el-page">
    <div class="el-title">
        <h3>Login</h3>
    </div>
    <form *ngIf="!awaitingOtp" [formGroup]="loginForm" (ngSubmit)="login()">
        <div class="el-formframe">
            <mat-form-field class="el-inputfield">
                <mat-label>Username</mat-label>
                <input matInput type="text" formControlName="username" placeholder="username"
                    autocomplete="on">
                <mat-error>This field is required</mat-error>
            </mat-form-field>
            <mat-form-field class="el-inputfield">
                <mat-label>Password</mat-label>
                <input matInput type="password" formControlName="password" placeholder="password" autocomplete="on">
                <mat-error>This field is required</mat-error>
            </mat-form-field>
            <div class="el-buttonframe">
                <button mat-raised-button color="primary" type="submit" class="el-button">Login</button>
                <button mat-raised-button color="secondary" type="reset" class="el-button"
                    (click)="resetForm()">Cancel</button>
            </div>

            <!--<a class="el-message" [routerLink]="[resetPasswordUrl]">Forgotten password?</a>-->

            <p class="el-message" [ngClass]="{'el-error-message': loginForm.errors?.['unauthenticated']}">{{message}}
            </p>
        </div>
    </form>
    <form *ngIf="awaitingOtp" [formGroup]="otpForm" (ngSubmit)="verify()">
        <div class="el-formframe">
            <p class="el-message">A verification code has been sent to your email address.</p>
            <mat-form-field class="el-inputfield">
                <mat-label>Verification code</mat-label>
                <input matInput type="text" formControlName="code" placeholder="6-digit code"
                    autocomplete="one-time-code">
                <mat-error>Enter the 6-digit code you received by email</mat-error>
            </mat-form-field>
            <div class="el-buttonframe">
                <button mat-raised-button color="primary" type="submit" class="el-button">Verify</button>
                <button mat-raised-button color="secondary" type="button" class="el-button"
                    (click)="resend()">Resend code</button>
                <button mat-raised-button color="secondary" type="button" class="el-button"
                    (click)="resetForm()">Cancel</button>
            </div>

            <p class="el-message" [ngClass]="{'el-error-message': otpForm.errors?.['unverified']}">{{message}}
            </p>
        </div>
    </form>
</div>
